var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.575 20.45C39.575 19.1333 39.4583 17.8833 39.2583 16.6667H20.425V24.1833H31.2083C30.725 26.65 29.3083 28.7333 27.2083 30.15V35.15H33.6417C37.4083 31.6667 39.575 26.5333 39.575 20.45Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.425 40C25.825 40 30.3417 38.2 33.6417 35.15L27.2083 30.15C25.4083 31.35 23.125 32.0833 20.425 32.0833C15.2083 32.0833 10.7917 28.5667 9.20832 23.8167H2.57499V28.9667C5.85832 35.5 12.6083 40 20.425 40Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20832 23.8167C8.79166 22.6167 8.57499 21.3333 8.57499 20C8.57499 18.6667 8.80832 17.3833 9.20832 16.1833V11.0333H2.57499C1.20832 13.7333 0.424988 16.7667 0.424988 20C0.424988 23.2333 1.20832 26.2667 2.57499 28.9667L9.20832 23.8167Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.425 7.91667C23.375 7.91667 26.0083 8.93334 28.0917 10.9167L33.7916 5.21667C30.3417 1.98333 25.825 0 20.425 0C12.6083 0 5.85832 4.50001 2.57499 11.0333L9.20832 16.1833C10.7917 11.4333 15.2083 7.91667 20.425 7.91667Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.243ad33327eb0adb93f9fd9d88b6f360.svg";
export { ForwardRef as ReactComponent };